import { render, staticRenderFns } from "./IncomeSourcePercentage.vue?vue&type=template&id=7bb6074d"
import script from "./IncomeSourcePercentage.vue?vue&type=script&lang=js"
export * from "./IncomeSourcePercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports